// This file is auto-generated by prebuild.js. Do not edit!
var tf = require("@tensorflow/tfjs");
export default tf;
